import * as React from 'react';
import styled from '@emotion/styled';
import { CenterWidget } from './CenterWidget';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect } from 'react';

export interface PageWidgetProps {
  width?: number;
  center?: boolean;
  title: string;
  topPadding?: number;
}

export const PageWidget: React.FC<React.PropsWithChildren<PageWidgetProps>> = (props) => {
  useEffect(() => {
    document.title = `JourneyApps | ${props.title}`;
  }, [props.title]);
  return (
    <AnimatePresence>
      <motion.div
        initial={{
          opacity: 0,
          transform: 'translateY(20px)'
        }}
        animate={{
          opacity: 1,
          transform: 'translateY(0)'
        }}
      >
        {(props.center ?? true) ? (
          <S.ScrollContainer width={props.width} topPadding={props.topPadding}>
            {props.children}
          </S.ScrollContainer>
        ) : (
          <S.Container topPadding={props.topPadding}>{props.children}</S.Container>
        )}
      </motion.div>
    </AnimatePresence>
  );
};
namespace S {
  export const Container = styled.div<{ topPadding?: number }>`
    padding-bottom: 100px;
    padding-top: ${(p) => p.topPadding ?? 50}px;
  `;
  export const ScrollContainer = styled(CenterWidget)<{ topPadding?: number }>`
    padding-bottom: 100px;
    padding-top: ${(p) => p.topPadding ?? 50}px;
  `;
}
